import logo from '@image/logo.svg';
import logoCollapsed from '@image/logo-collapsed.svg';
import goLogo from '@image/go-logo.svg';

interface LogoProps {
  type: 'primary' | 'secondary' | 'go';
  className?: string;
}

const Logo = ({ type, className }: LogoProps) => {
  let logoSrc, altText;

  if (type === 'primary') {
    logoSrc = logo;
    altText = 'Primary Logo';
  } else if (type === 'secondary') {
    logoSrc = logoCollapsed;
    altText = 'Augmedix Collapsed Logo';
  } else if (type === 'go') {
    logoSrc = goLogo;
    altText = 'Augmedix Go Logo';
  }

  return (
    <div className={`${className}`}>
      <img
        src={logoSrc}
        alt={altText}
      />
    </div>
  );
};

export default Logo;
